// extracted by mini-css-extract-plugin
module.exports = {"root":"Thumbnail_root__1BIu2","root__isHighlighted":"Thumbnail_root__isHighlighted__3KTn_","img":"Thumbnail_img___HJeS"};